export const ProjectDetailsTranslations = {
  en: {
    projectDetails: {
      header: "Details",
      downloadLabel: "Download PDF",
      creationDateLabel: "Creation Date",
      descriptionLabel: "Description",
      electricalDataTitle: "Electrical Data",
      noProjectsTitle: "You haven’t calculated anything yet.",
      noProjectsDescription: "Once you run a performance, it will appear here.",
      noProjectLabel: "Select a performance to open its sheet.",
      condenserDataCard: {
        title: "Condenser Data",
        ambianceTemperature: "Ambient temperature",
        altitude: "Altitude",
        minOperatingTemp: "Min operating temp",
        maxOperatingTemp: "Max operating temp",
      },
      electricalDataCard: {
        compressorType: "Compressor type",
        compressorQuantity: "Compressor quantity",
        perCompressorAmps: "Per compressor Amps",
        compressorRLA: "Compressor RLA",
        compressorLRA: "Compressor LRA",
        perCompressorKW: "Per compressor kW",
        heatRejectionKW: "Heat rejection kW",
        condenserType: "Condenser type",
        perFanAmps: "Per fan Amps",
      },
      heatExchangerDataCard: {
        title: "Heat exchanger data",
        enteringFluidTemp: "Entering fluid temp",
        leavingFluidTemp: "Leaving fluid temp",
        flowRate: "Flow rate",
        fluid: "Fluid",
        pressureDrop: "Pressure drop",
        foulingFactor: "Fouling factor",
        evaporatorType: "Evap. type",
        evaporatorQuantity: "Evap. quantity",
      },
      performanceDataCard: {
        title: "Performance Data",
        coolingCapacity: "Cooling capacity:",
        cop: "COP:",
      },
    },
  },

  es: {
    projectDetails: {
      header: "Detalles",
      downloadLabel: "Descargar PDF",
      creationDateLabel: "Fecha de creación",
      descriptionLabel: "Descripción",
      electricalDataTitle: "Datos eléctricos",
      noProjectsTitle: "Todavía no has calculado nada.",
      noProjectsDescription: "En cuanto calcules una hoja, aparecerá aquí.",
      noProjectLabel: "Selecciona una hoja de performance para abrirla.",
      condenserDataCard: {
        title: "Datos del condensador",
        ambianceTemperature: "Temperatura ambiente",
        altitude: "Altitud",
        minOperatingTemp: "Temp. mínima de operación",
        maxOperatingTemp: "Temp. máxima de operación",
      },
      electricalDataCard: {
        compressorType: "Tipo de compresor",
        compressorQuantity: "Cantidad de compresores",
        perCompressorAmps: "Amperes por compresor",
        compressorRLA: "RLA del compresor",
        compressorLRA: "LRA del compresor",
        perCompressorKW: "kW por compresor",
        heatRejectionKW: "Rechazo de calor (kW)",
        condenserType: "Tipo de condensador",
        perFanAmps: "Amperes por ventilador",
      },
      heatExchangerDataCard: {
        title: "Datos del intercambiador de calor",
        enteringFluidTemp: "Temp. fluido de entrada",
        leavingFluidTemp: "Temp. fluido de salida",
        flowRate: "Caudal",
        fluid: "Fluido",
        pressureDrop: "Caída de presión",
        foulingFactor: "Factor de incrustación",
        evaporatorType: "Tipo de evaporador",
        evaporatorQuantity: "Cantidad de evaporadores",
      },
      performanceDataCard: {
        title: "Datos de rendimiento",
        coolingCapacity: "Capacidad de enfriamiento:",
        cop: "COP:",
      },
    },
  },
};
